import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/library", label: "番剧库" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 md:px-6 py-3.5">
        <Link to="/" className="flex items-center gap-2.5 group" aria-label="小水看番 首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50 text-xl transition-transform group-hover:rotate-6">
            <i className="ri-bubble-chart-line" aria-hidden="true" />
          </span>
          <span className="font-heading text-2xl text-foreground-950">小水看番</span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                pathname === link.to
                  ? "bg-primary-100 text-primary-800 font-semibold"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/library"
            className="ml-3 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            <i className="ri-movie-2-line" aria-hidden="true" />
            去追番
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-900 md:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50/95 backdrop-blur md:hidden">
          <div className="flex flex-col gap-1 px-4 py-4">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`rounded-lg px-4 py-2.5 text-sm whitespace-nowrap ${
                  pathname === link.to
                    ? "bg-primary-100 text-primary-800 font-semibold"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}